/**
 * Telefon raqamni 998 bilan yuborish majburiy!
 */
export const onOpenVerifyBot = (phone: string) => {
  const url = `https://t.me/akamuz_verify_bot?start=${phone?.replace(/[\s+-]/g, '')}`;

  return window.open(url, '_blank', 'width=400,height=400');
};
